import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from './Alert';

import { useTranslation } from 'react-i18next';
import {loadConfig} from "../helper/utils";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
    	padding: theme.spacing(2),
  	},
  	'& .MuiDialogActions-root': {
    	padding: theme.spacing(1),
  	},
}));

export default function LoadConfig(props) {
  	const [ email, setEmail] = React.useState("mgoergen@reimo.com");
  	const [ config, setConfig] = React.useState("jq3yyUHT");
  	const [ openBD, setOpenBD] = React.useState(false);
	const [displayAlert, setDisplayAlert] = React.useState(false);
	const [displayAlertMsg, setDisplayAlertMsg] = React.useState("");
	
  	const handleClose = () => {
    	props.setDisplayConfig(false);
  	};
  	
  	const { t, i18n } = useTranslation("",{lng: props.language});
	const handleUserInput = () => {
	};

  	const handleCloseBD = () => {
    	setOpenBD(false);
  	};

  	let navigate = useNavigate(); 

	async function loadConfiguration()  {
		try {
			setOpenBD(true);

			const json = await loadConfig(config, email);
			navigate("/configureexpansion/"+ json.carId, { state: { configData: json } });
			
		    setOpenBD(false);
		} catch (error) {
		    console.log("konfiguration konnte nicht geladen werden", error);
		    handleClose();
		    setOpenBD(false);
		    setDisplayAlert(true);
			setDisplayAlertMsg("Konfiguration konnte nicht geladen werden");

		}		
  	}; 



  	return (
    	<React.Fragment>
    		<Alert display={displayAlert} displayAlertMsg={displayAlertMsg} setDisplayAlert={setDisplayAlert}/>

      		<BootstrapDialog 	open={props.display}
			        			onClose={handleClose}
			        			aria-labelledby="alert-dialog-title"
			        			aria-describedby="alert-dialog-description"
								sx={{
								      "& .MuiDialog-container": {
								        "& .MuiPaper-root": {
								          width: { xs: "360px", md: "720px", lg: "720px" } ,
								          minWidth: { xs: "360px", md: "720px", lg: "720px" },  
								        },
								      },
								}}
			>
				<DialogTitle id="alert-dialog-title">
	         		{t("Konfiguration laden")}
	        	</DialogTitle>
				<IconButton aria-label="close"
			          			onClick={handleClose}
			          			sx={{  	position: 'absolute',
			            				right: 8,
			            				top: 8,
			            				color: (theme) => theme.palette.grey[500],
			          			}}
			    >
	          		<CloseIcon />
	        	</IconButton>
	        	<DialogContent>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							<TextField	required
										id="email"
										name="email"
										label={t("EMail")}
										fullWidth
										autoComplete="given-name"
										variant="standard"
										value={email}
										onChange={e => {setEmail(e.target.value);handleUserInput()}}	
										onBlur={e => {setEmail(e.target.value);handleUserInput()}}												
			          		/>						
						</Grid>
	    				<Grid item xs={12} sm={6}>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField	required
										id="config"
										name="config"
										label={t("Konfiguration")}
										fullWidth
										autoComplete="given-name"
										variant="standard"
										value={config}
										onChange={e => {setConfig(e.target.value);handleUserInput()}}	
										onBlur={e => {setConfig(e.target.value);handleUserInput()}}												
			          		/>						
						</Grid>
					</Grid>
					
	        	</DialogContent>
	        	<DialogActions>
	        			<Button autoFocus 
								color="error"
								variant="contained"
								onClick={handleClose}
								endIcon={<CancelIcon />}>
				            {t("verwerfen")}
				        </Button>
						<Button autoFocus 
								variant="contained"
								onClick={loadConfiguration}>
				            {t("OK")}
				        </Button>
	        	</DialogActions>
      		</BootstrapDialog>
		      	<Backdrop
			        sx={{ color: '#fff', zIndex: 8000 }}
			        open={openBD}
			        onClick={handleCloseBD}
			      >
			        <CircularProgress color="inherit" />
			    </Backdrop>        		
		</React.Fragment>
  );
}